import {useEffect, useRef} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import isEqual from 'lodash.isequal';
import {useFilterContext} from "../infrastructure/FilterContext";
import {parseQueryToFilters, serializeFiltersToQuery} from "../infrastructure/filterUrlMapper";

export const useFilterUrlSync = () => {
    const {filters, updateFilters} = useFilterContext();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!location.pathname.startsWith('/articulos')) return;

        const urlFilters = parseQueryToFilters(new URLSearchParams(location.search));

        const isContextEmpty = Object.keys(filters).length === 0;

        if (isContextEmpty && !isEqual(urlFilters, filters)) {
            updateFilters(urlFilters);
        }
    }, [location.search]);

    useEffect(() => {
        if (!location.pathname.startsWith('/articulos')) return;

        const currentUrlParams = new URLSearchParams(location.search);
        const serialized = serializeFiltersToQuery(filters);
        const serializedParams = new URLSearchParams(serialized.toString());

        const areEqual = serializedParams.toString() === currentUrlParams.toString();

        if (!areEqual) {
            navigate(
                {
                    pathname: location.pathname,
                    search: `?${serialized.toString()}`,
                },
                {replace: true}
            );
        }
    }, [filters]);
};


